import { Language } from "@shared/modules/navigation/types/navbar-types";
import { useTranslation } from "@shared/utils/internationalization";
import moment from "moment";
import "moment/locale/fr"; // needed to display dates/times in French
import { useCallback, useMemo } from "react";

/**
 * A shared hook that manages language switching functionality across all applications.
 * Handles both i18n translations and moment.js locale changes between English and French.
 */

export const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language as Language | undefined;

  const setMomentLocale = () => {
    moment.locale(currentLanguage);
  };

  const toggleLanguage = useCallback(() => {
    const updatedLanguage = currentLanguage === "fr" ? "en" : "fr";
    i18n.changeLanguage(updatedLanguage);
    moment.locale(updatedLanguage);
  }, [currentLanguage, i18n]);

  const language = useMemo(() => {
    return currentLanguage === "fr" ? "French" : "English";
  }, [currentLanguage]);

  return {
    isReady: Boolean(i18n) && Boolean(i18n.language),
    language,
    languageCode: currentLanguage,
    toggleLanguage,
    setMomentLocale,
  };
};
